import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareAlt } from "@fortawesome/free-solid-svg-icons";

const ShareButton = ({ onClick }) => {
  return (
    <button className="icon-button" onClick={onClick}>
      <FontAwesomeIcon icon={faShareAlt} />
    </button>
  );
};

export default ShareButton;
